/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionGoToAddUser';

const ActionGoToAddUserManager: ActionManagerFn<'ActionGoToAddUser'> = (
  platform: Platform,
): ActionManager<'ActionGoToAddUser'> => {
  return {
    ...baseActionManager(platform, 'ActionGoToAddUser'),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'Go To Add User',
    icon: { iconName: 'external-link' },
    description: `**Overview**<br/>
The "Go To Add User" action is a specialized, system-level navigation component identified primarily for internal use within the platform. Its specific function is to initiate a navigation event that directs the user to the interface responsible for creating or onboarding new Users.<br/><br/>
This component operates with a fixed internal behavior, leveraging the platform's routing logic to bridge the user specifically to the user creation workflow. It requires no specific configuration or parameters from the developer, functioning as a pre-configured shortcut.

**Key Features**<br/>
* **Internal Utility:** Explicitly designated as a "CloudIO Internal Action," indicating it is intended for use within administrative or builder contexts rather than standard end-user applications.
* **Fixed Destination:** Functionally hardcoded to route to the "Add User" interface, eliminating the need for manual target configuration.
* **Zero Configuration:** Inherits all properties directly from baseActionManager and baseActionProps, accepting only the standard configuration options available to all actions.

**Properties**<br/>
* **Base Properties:** This component utilizes ...baseActionProps exclusively, without defining any component-specific input fields.

**Use Cases**<br/>
* **Admin Dashboards:** Integrated into an administrative panel to allow administrators to quickly register new users.
* **Builder Shortcuts:** Used within the platform's development environment to provide developers with quick access to user management settings.`,
  };
};

export default ActionGoToAddUserManager;
